module.exports = __webpack_public_path__ + "assets/img/2181591934007_.pic_hd.8df59015.jpg";